var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"homeView"}},[_c('CommonHeader'),_c('HomeCenter'),_c('CommonBottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }